import { render } from "./FormReport.vue?vue&type=template&id=a0f40936"
import script from "./FormReport.vue?vue&type=script&lang=js"
export * from "./FormReport.vue?vue&type=script&lang=js"

import exportComponent from "/builds/shapkin/crm-mentoring.exportedu.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__